var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgexport18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-v-7a6cd066": "",
    width: 16,
    height: 64,
    viewBox: "0 0 16 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hidden m:inline-block relative z-2 button-fit-arrow-svg to-arrow-black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-7a6cd066": "",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28027 0.27636L9.27713 59.9036L13.9743 55.2064C14.3682 54.8125 14.5929 55.2542 15.0039 55.6652C15.4149 56.0763 15.8567 56.301 15.4628 56.6949L9.04372 63.1139C8.64981 63.5078 7.99728 63.4939 7.58625 63.0829L0.888126 56.3848C0.477094 55.9737 1.00354 55.6737 1.30354 55.3737C1.60355 55.0737 1.90355 54.5473 2.31458 54.9583L7.21596 59.8597L7.21587 0.280228L9.28027 0.27636Z",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport18);
export default __webpack_public_path__ + "static/media/svgexport-18.e44509db793ce3ef56895f9a318805da.svg";
export { ForwardRef as ReactComponent };